/**
 * UBO fields that ops can edit through a user edit request
 */
export const UBO_EDIT_FIELDS = [
  'ubo_gender',
  'ubo_firstname',
  'ubo_lastname',
  'ubo_birthdate',
  'ubo_ifu_country_of_birth',
  'ubo_ifu_place_of_birth',
  'ubo_ifu_postcode_of_birth',
  'ubo_country_of_tax_residence',
  'ubo_nationality',
  'ubo_other_nationality',
  'ubo_tax_number',
  'ubo_pep_status',
  'ubo_is_not_us_person',
  'ubo_home_address_postalcode',
  'ubo_home_address_street',
  'ubo_home_address_flat_building',
  'ubo_home_address_city',
] as const;

export type UboEditField = (typeof UBO_EDIT_FIELDS)[number];

export function isUboEditField(field: string): field is UboEditField {
  return UBO_EDIT_FIELDS.includes(field as UboEditField);
}

export type UboFieldToColumn<F extends UboEditField> = F extends `ubo_${infer Column}`
  ? Column
  : never;

export type UboColumn = UboFieldToColumn<UboEditField>;

export function uboFieldToColumn<F extends UboEditField>(field: F): UboFieldToColumn<F> {
  return field.replace('ubo_', '') as UboFieldToColumn<F>;
}

export const UBO_COLUMNS: readonly UboColumn[] = UBO_EDIT_FIELDS.map(uboFieldToColumn);
